var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevronDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 15.513,
    viewBox: "0 0 29 15.513",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_369",
    "data-name": "Group 369",
    transform: "translate(-22 -77.778)",
    opacity: 0.797
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_metro-chevron-thin-down",
    "data-name": "Icon metro-chevron-thin-down",
    d: "M31.737,10.994a1.174,1.174,0,0,1,1.651,0,1.146,1.146,0,0,1,0,1.634l-13.333,13.2a1.174,1.174,0,0,1-1.651,0L5.071,12.628a1.148,1.148,0,0,1,0-1.634,1.174,1.174,0,0,1,1.651,0L19.23,23.034Z",
    transform: "translate(17.271 67.123)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDown);
export default __webpack_public_path__ + "static/media/chevron-down.66b6c3277da2586e7742cba704bafd91.svg";
export { ForwardRef as ReactComponent };